import React, { useEffect, useState } from "react"
import styles from "./index.module.scss"
import openGuidePic  from "../assets/pic_微信打开引导.png";
import useHtmlFontSize from '@/hooks/useHtmlFontSize'

const App = () => {

  // const [navIsWeiXin, setNavIsWeiXin] = useState(true)
  const bottomTextFromNav = '若APP内扫码无效，请升级至最新版本APP。'
  const bottomTextFromApp = '当前版本暂不支持，请升级至最新版本APP。'
  const [bottomTextConten, setBottomTextContent] = useState('')


  // type：代表扫码路径 0-微信 1-普通浏览器 2-app里面
  const [type, setType] = useState(1)
  // hasAppLink: 能否从app内部完成跳转
  const [hasAppLink, setHasAppLink] = useState(false)
  // 判断是从什么客户端扫码的 0 安卓 1 ios
  const [clientType, setClientType] = useState(0)
  // 
  const [targetUrl, setTargetUrl] = useState('xiaopeng://ble/checkactivity')

  // 是否鸿蒙app
  const [isHarmony, setIsHarmony] = useState(false)

  useHtmlFontSize({
    rules: [{ minWidth: 390, fontSize: '100px' }]
  })

  const enterNav = () => {
    const ua = window.navigator.userAgent
    let search = window.location.search
    let index = search.indexOf("=")
    let url = decodeURIComponent(search.substring(index + 1, search.length)) || 'xiaopeng://ble/checkactivity'
    setTargetUrl(url)
    if (ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1) {
      setClientType(0)
    }
    if (!!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) ) {
      setClientType(1)
    }
    
    if (/MicroMessenger/i.test(ua)) {
      setType(0)
      setBottomTextContent(bottomTextFromNav)
      window.location.href = targetUrl
    } else if (/xiaopeng/i.test(ua)) {
      setType(2)
      if (ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1) {
        setHasAppLink(true)
        window.location.href = 'xiaopeng://ble/checkactivity'
      } else if (!!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/i)) {
        // window.location.href = targetUrl
        let matchArr = ua.match(/xiaopengqicheenterprise\/(.*)\(/i) || ua.match(/xiaopengqiche\/(.*)\(/i) 
        let versionArr = matchArr?.[1].trim().split('.')
        // ios app 版本小于4.29的不可以内部唤醒
        console.log(versionArr)
        if (versionArr) {
          if (parseInt(versionArr[0]) < 4) {
            setHasAppLink(false)
            setBottomTextContent(bottomTextFromApp)
          } else if (parseInt(versionArr[0]) === 4 && parseInt(versionArr[1]) < 29) {
            setHasAppLink(false)
            setBottomTextContent(bottomTextFromApp)
          } else {
            setHasAppLink(true)
            window.location.href = targetUrl
          }
        }
      } else if (/Harmony/i.test(ua)) {
        setIsHarmony(true)
      }
    } else {
      setType(1)
      setBottomTextContent(bottomTextFromNav)
      window.location.href = targetUrl
    }
  }

  const handleOpenApp = () => {
    window.location.href = targetUrl
  }

  const handleDownload = () => {
    if (clientType === 0) {
      window.open('https://www.xiaopeng.com/download_sharetrace.html')
    } else {
      // window.location.href = 'https://apps.apple.com/cn/app/%E5%B0%8F%E9%B9%8F%E6%B1%BD%E8%BD%A6/id1331318404'
      window.open('https://a.xiaopeng.com/dl/gw')
    }
  }

  const checkOrUpdate = () => {
    if (hasAppLink) {
      window.location.href = targetUrl
    } else {
      if (clientType === 0) {
      window.open('https://www.xiaopeng.com/download_sharetrace.html')
      } else {
        // window.location.href = 'https://apps.apple.com/cn/app/%E5%B0%8F%E9%B9%8F%E6%B1%BD%E8%BD%A6/id1331318404'
        window.open('https://a.xiaopeng.com/dl/gw')
      }
    }
  }

  useEffect(() => {
    document.title = "钥匙检查与启动"
    enterNav()
  }, [])

  return (

    <div className={styles.homePage}>
      <div className={styles.linearGradien}>
        { type === 0 ? 
        <div className={styles.weiXinContainer}>
          <div className={styles.model}></div>
          <img className={styles.guidePic} src={openGuidePic} alt="" />
        </div>
        : null }
        { isHarmony ? 
          <div className={styles.harmonyContainer}>
            <div className={styles.errorContainer}>
              <div className={styles.errorPic}></div>
            </div>
            <div className={styles.textContainer}>
              <div className={styles.title}>敬请期待</div>
              <div className={styles.desc}>暂不支持鸿蒙系统</div>
            </div>
          </div> :
          <>
            <div className={styles.topContainer}>
              <div className={styles.topBgp}>
                <div className={styles.bannerText}>
                  <div className={styles.titleText}>钥匙检查与启动</div>
                  <div>
                    <div className={styles.topText}>
                      <span>帮您一键排除无法启动、无法解闭锁等问题{ hasAppLink === true ? null : <span>,</span>}</span><br />
                      { hasAppLink === true ?  null : <span>请下载或打开小鹏汽车APP再扫码。</span>}
                    </div>
                    <div className={styles.bottomText}>{bottomTextConten}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.bottomContainer}>
              { 
                type === 0 || type === 1 ?
              <div>
                <div className={[styles.btn, styles.openApp].join(' ')} onClick={handleOpenApp}>打开小鹏汽车APP</div>
                <div className={styles.downLoad} onClick={handleDownload}>下载安装最新版</div>
              </div> :
              <div className={[styles.btn, styles.updateNow].join(' ')} onClick={checkOrUpdate}>
                <span>{ hasAppLink ? '立即检查': '立即升级'}</span>
              </div>
              }
            </div>
          </>
        }
      </div>
    </div>
  )
}

export default App